/* eslint-disable no-unused-vars */
import React from 'react';
import { useSelector } from 'react-redux';
import { useT } from 'talkr';
import DefaultOption from '../../../components/defaultOption';
import s from './index.module.scss';
import multiOption from '../../styles/multiOption.module.scss';
import common from '../../index.module.scss';
import optionsImages from '../../../survey/optionsImages';
import questionsMethods from '../../../survey/questions';

function DefaultQuestion(props) {
  const { T } = useT();
  const { options, name } = props.step;
  const isExpandedDesign = props.isExpandedDesign ? multiOption.designExpanded : '';
  const isExpandedDesignImg = props.isExpandedDesign ? multiOption.expandedImg : '';
  const age = questionsMethods.getAnswers({ questionName: 'age' }).value;

  return (
    <section className={`${common.step} ${s.withIcon}`}>
      <div className={`${common.stepTitle} ${s.stepTitle}`}>{T(`${name}_title`)}</div>
      <div className={s.options}>
        {
          options && Object.entries(options).map((option) => {
            const imgSrc = optionsImages[name][option[1].value];
            const isExpandedDesignStyle = isExpandedDesign && isExpandedDesignImg ? multiOption.withImg : '';

            return (
              <DefaultOption
                key={option[1].value}
                className={`${multiOption.option} ${s.option} ${isExpandedDesign} ${isExpandedDesignStyle}`}
                selectedStateClass={multiOption.optionSelected}
                option={option[1]}
                questionName={name}
                disableFromFocus={!props.isThisCurrentStep}
                resetIfValueSelected={props.resetIfValueSelected}
              >
                <div className={s.infoWrapper}>
                  <p dangerouslySetInnerHTML={{ __html: T(`${name}_${option[1].value}`) }} />
                  <div className={`${multiOption.checkbox} ${s.checkbox}`} />
                </div>

              </DefaultOption>
            );
          })
        }
      </div>
    </section>
  );
}

function MultiOptions(props) {
  const questions = useSelector((state) => state.questions.list);
  const questionName = props.stepData.name;
  const question = questions[questionName];
  const { isThisCurrentStep } = props;
  const { isCurrentStepCompleted } = props;
  const isThisCurrentStepClass = isThisCurrentStep ? s.stepSelected : '';
  const isThisStepCompletedClass = isCurrentStepCompleted ? s.stepCompleted : '';
  const { resetIfValueSelected } = props;
  const config = useSelector((state) => state.steps.config);

  return (
    <div className={`${s.step} ${isThisCurrentStepClass} ${isThisStepCompletedClass}`}>
      <DefaultQuestion
        step={question}
        index={1}
        isThisCurrentStep={isThisCurrentStep}
        isExpandedDesign={props.designExpanded}
        resetIfValueSelected={resetIfValueSelected}
      />
    </div>
  );
}

export default MultiOptions;
